export const es = {
    nav: {
        overview: 'Resumen',
        cases: 'Casos',
        ai_visibility: 'Visibilidad IA',
        dark_web: 'Dark Web',
        address: 'Monitoreo de Dirección',
        guides: 'Guías',
        details: 'Mis Datos',
        settings: 'Ajustes',
        plans: 'Planes',
        support: 'Soporte',
        home: 'Inicio',
        how_it_works: 'Cómo funciona',
        pricing: 'Precios',
        faq: 'Preguntas frecuentes',
        login: 'Iniciar sesión',
        get_started: 'Empezar',
        dashboard: 'Panel de Control',
        continue_onboarding: 'Continuar Configuración',

        security: 'Seguridad',

        reviews: 'Reseñas',
        about: 'Sobre nosotros',
        careers: 'Carreras',
        press: 'Prensa',
        contact: 'Contacto',
        help_center: 'Centro de ayuda'
    },
    greeting: 'Bienvenido',
    search: {
        placeholder: 'Buscar sitios...',
    },
    notifications: {
        title: 'Notificaciones',
        none: 'No hay nuevas notificaciones',
        time_just_now: 'Ahora mismo',
        time_minutes: 'min atrás',
        time_hours: 'h atrás',
        time_days: 'd atrás',
        removed: 'Eliminado de',
        processing: 'Eliminación iniciada:',
        action: 'Acción requerida:',
        submitted: 'Nueva solicitud:',
        update: 'Actualización:'
    },
    dropdown: {
        signed_in: 'Sesión iniciada como',
        details: 'Mis Datos',
        settings: 'Ajustes',
        plans: 'Planes y Precios',
        logout: 'Cerrar sesión',
        support: 'Soporte',
        appearance: 'Apariencia',
        light: 'Claro',
        dark: 'Oscuro',
        language: 'Idioma',
        active: 'Activo'
    },
    titles: {
        dashboard: 'Panel de Control',
        protection_score: 'Puntuación de Protección',
        scanning: 'Escaneando...',
        protection_active: 'Protección Activa',
        overview_welcome: 'Aquí tienes tu último resumen',
        link_removal_desc: 'Solicita la eliminación de enlaces de la web y motores de búsqueda',
        ai_visibility_desc: 'Monitorea y restringe tu visibilidad en servicios de IA',
        dark_web_desc: 'Comprueba si tus datos se han filtrado en brechas de datos'
    },
    cards: {
        analysis_title: 'Analizando tu visibilidad',
        analysis_text: 'Estamos analizando tu visibilidad en bases de datos y buscadores. Te notificaremos cuando termine.',
        cases_title: 'Casos en curso',
        cases_desc: 'Estado de tus eliminaciones',
        site_status_title: 'Estado de información',
        site_status_desc: 'Tu visibilidad en las principales bases de datos',
        status_visible: 'Visible',
        status_protected: 'Protegido',
        new: 'Nuevo',
        no_cases: 'Sin casos aún.',
        view_all: 'Ver todos',
        address_tab: 'Dirección',
        alarm_tab: 'Alerta',
        your_address: 'Tu Dirección',
        active: 'Aktiv',
        coming_soon: 'Próximamente',
        dev_text: 'Esta función está en desarrollo.',
        link_removal: 'Eliminación de enlaces'
    },
    premium_modal: {
        title: 'Desbloquear Premium',
        desc: 'Para borrar y ocultar automáticamente sus datos de las bases de datos y los motores de búsqueda, se requiere una suscripción Premium activa.',
        feature1: 'Eliminación de más de 7 sitios',
        feature2: 'Desindexación de Google',
        feature3: 'Monitoreo continuo 24/7',
        feature4: 'Re-eliminación automática',
        button: 'Actualizar a Premium',
        error: 'No se pudo iniciar el pago. Por favor inténtalo de nuevo.',
        pro_success_title: 'Tienes Noctra Pro',
        pro_success_desc: 'Tus datos ahora se eliminan automáticamente y monitoreamos tu privacidad 24/7.',
        manage_subscription: 'Gestionar suscripción',
        portal_error: 'No se pudo abrir el portal. Inténtalo de nuevo.'
    },
    removal_upgrade: {
        title: 'Protege tu identidad de verdad',
        desc: 'Actualiza a Premium para eliminar tus datos de Google y más de 30 sitios. Gestionamos todo el proceso por ti — automáticamente.',
        feature1: 'Eliminación de más de 7 sitios de datos',
        feature2: 'Desindexación de Google de tus datos',
        feature3: 'Monitoreo continuo y re-eliminación',
        feature4: 'Soporte personal e informe de eliminación',
        button: 'Ver planes y actualizar',
        guarantee: 'Derecho de desistimiento de 14 días · Cancela en cualquier momento'
    },
    modal: { title: 'Iniciar nueva eliminación', desc: 'Selecciona de qué base de datos quieres eliminar tus datos.', select_site: 'Seleccionar Sitio', start_btn: 'Iniciar Eliminación', starting_btn: 'Iniciando...' },
    guides: {
        remove: 'Eliminar', show: 'Mostrar', hide: 'Ocultar', step_prefix: 'Paso',
        click_remove: "Haga clic en 'Eliminar'",
        enter_name: "Ingrese su nombre en el cuadro de búsqueda",
        bankid: "Identifíquese con Mobile BankID",
        hide_details: "Ocultar sus datos",
        hide_address_phone: "Ocultar su dirección y número de teléfono",
        click_hide: "Haga clic para ocultar sus datos",
        remove_details: "Eliminar sus datos",
        info_banner: 'Aquí puedes ver todas nuestras guías paso a paso con enlaces directos',
        view_all_btn: 'Ver todas las guías'
    },
    support: {
        title: 'Soporte',
        faq: 'Preguntas frecuentes',
        new_message: 'Nuevo mensaje',
        inbox: 'Bandeja de entrada',
        no_history: 'No tienes historial de mensajes',
        start_chat: 'Escribe para iniciar la conversación',
        type_here: 'Escribe aquí...'
    },
    common: {
        view_all: 'Ver todo',
        protected: 'Protegido',
        warning: 'Advertencia',
        critical: 'Crítico',
        loading: 'Cargando...',
        recently: 'Hace poco',
        more_features: 'Más funciones',
        more: 'Más',
        protect: 'Proteger',
        beta: 'Beta'
    },
    status: {
        privacy_level: 'Nivel de Privacidad',
        fully_protected: 'Completamente Protegido',
        partially_protected: 'Parcialmente Protegido',
        vulnerable: 'Vulnerable',
        removed: 'Eliminado',
        processing: 'Procesando',
        action: 'Acción Requerida',
        submitted: 'Enviado'
    },
    landing: {
        seo: {
            title: "Noctra - Elimina tus datos personales de la red",
            description: "Protégete contra el robo de identidad y el acoso. Noctra elimina tus datos de Ratsit, MrKoll, Hitta.se y muchos más."
        },
        hero: {
            remove: "Elimina",
            from_web: "De la red con",
            subtitle: "Protege tu privacidad. Eliminamos tus datos de sitios como Ratsit, MrKoll y Hitta.se – automáticamente.",
            subtitle_long: "Tus datos personales están expuestos en la red. Los encontramos. Los eliminamos. Y te protegemos.",
            cta_start: "Buscar y eliminarme",
            cta_how: "Cómo funciona",
            cta_protected: "Protégete ahora",
            no_binding: "Sin permanencia. Empieza ahora.",
            trust: "Conectado a Google Ads y Stripe para su seguridad"
        },
        benefits: {
            title: "¿Por qué elegir Noctra?",
            subtitle: "Ofrecemos más que solo la eliminación de datos. Te damos la libertad de vivir tu vida sin preocuparte por tu seguridad digital."
        },
        social_proof: {
            secure_payment: "Pague de forma segura con",
            guarantees: {
                refund: "Derecho de desistimiento de 14 días",
                cancel: "Cancela en cualquier momento",
                no_fees: "Sin cargos ocultos"
            }
        },
        family: {
            title: "Invisible en la red, seguro en la realidad",
            subtitle: "Protección para toda la familia, evita que otros descubran tus datos privados",
            description: "Nombres, direcciones, números de teléfono, detalles familiares y otros datos privados son vendidos continuamente por corredores de datos. Nosotros lo detenemos.",
            protect_list_title: "Qué protegemos:",
            button: "Protege a tu familia ahora",
            tags: {
                name: "Nombre",
                age: "Edad",
                address: "Dirección",
                home_value: "Valor de la vivienda",
                phone: "Número de teléfono",
                mail: "Correo electrónico",
                marital_status: "Estado civil",
                relatives: "Parientes",
                images: "Imágenes",
                prev_addresses: "Direcciones anteriores"
            }
        },
        footer: {
            service_title: "Servicio",
            company_title: "Empresa",
            help_title: "Ayuda y Recursos",
            privacy_policy: "Política de privacidad",
            terms: "Términos de servicio",
            cookie_policy: "Política de cookies",
            all_rights_reserved: "Todos los derechos reservados.",
            part_of: "Noctra es parte de Lumidiom AB.",
            secure_payment: "Pago seguro"
        },
        words: {
            address: "tu dirección",
            phone: "tu número",
            person: "a ti mismo",
            personal_data: "tus datos"
        },
        benefits_cards: {
            control_title: "Recupera el control",
            control_desc: "Tú decides quién debe saber dónde vives. Te damos el poder sobre tus datos eliminándolos de los registros públicos.",
            control_badge: "100% Control",
            support_title: "Ayuda personal",
            support_desc: "Sin robots, solo personas reales. Nuestro equipo de soporte está aquí para ayudarte con todo lo relacionado con tu seguridad.",
            support_badge: "Soporte Premium"
        },
        risks: {
            title: "Tus datos están expuestos a todos",
            subtitle: "En muchas regiones, los datos personales son registros públicos. Sin una protección activa, cualquiera puede encontrar tu dirección, ingresos y situación familiar en segundos.",
            card1: {
                title: "Robo de ID y Fraude",
                desc: "Los estafadores utilizan tus datos públicos para pedir préstamos, pedir bienes o abrir suscripciones a tu nombre."
            },
            card2: {
                title: "Acoso y Amenazas",
                desc: "Tu hogar debe ser tu castillo. Las direcciones públicas facilitan que personas no autorizadas te busquen a ti y a tu familia."
            },
            card3: {
                title: "Spam y Vendedores",
                desc: "Tus datos se venden a empresas que te bombardean con publicidad. Cortamos el flujo en la fuente."
            }
        },
        pricing_section: {
            title: "Empieza a protegerte hoy mismo",
            subtitle: "Elige el plan que mejor se adapte a ti",
            yearly: "Plan anual",
            monthly: "Mensual",
            save_text: "Ahorra hasta un 16%",
            pro_exclusive: "Incluido en Pro",
            guarantee: "14 días de derecho de desistimiento · Cancela en cualquier momento",
            bas_title: "Básico",
            pro_title: "Pro",
            onetime_title: "¿Solo necesitas una solución puntual?",
            onetime_desc: "Eliminamos tus datos de todos los sitios y enviamos un informe con pruebas. Sin suscripción.",
            onetime_btn: "Limpieza única — 99 kr",
            cta: "Protégete ahora",
            best_value: "Mejor valor",
            save_badge: "Ahorras",
            per_person: "Solo {price} kr/persona",
            month_unit: "mes",
            year_unit: "año",
            add_family: "Añadir miembros de la familia (+29 kr/mes)",
            payment_error: "No se pudo iniciar el pago. Inténtalo de nuevo.",
            no_commitment: "Sin compromiso",
            features: {
                google_removal: "Desindexación de Google (5 enlaces)",
                google_removal_pro: "Desindexación de Google (10 enlaces)",
                personal_support: "Soporte personal",
                priority_support: "Soporte prioritario",
                no_commitment: "Sin compromiso",
                darkweb_monitoring: "Monitoreo de Dark Web",
                ai_visibility: "Visibilidad de IA (ChatGPT, Gemini, etc.)",
                one_person: "1 Persona",
                two_persons: "2 Personas incluidas",
                removal_7_sites: "Eliminación de más de 7 sitios de datos",
                removal_report: "Informe de eliminación con pruebas",
                monitoring_24_7: "Monitoreo continuo 24/7",
                auto_removal: "Eliminación automática recurrente",
                address_alarm: "Alarma de dirección",
                dashboard: "Panel de Noctra",
                all_basic_included: "Todo lo de Bas incluido",
                protection_1_person: "Protección continua — 1 persona",
                protection_2_persons: "Protección máxima — 2 personas incl."
            }
        },
        newsletter: {
            title: "Mantente un paso adelante – cada semana",
            subtitle: "Como cliente Pro, recibes un boletín de seguridad exclusivo cada semana con guías detalladas, amenazas actuales y consejos prácticos para proteger tu identidad.",
            button: "Mejorar a Pro",
            features: [
                { text: 'Estrategias de contraseña y 2FA', icon: 'KeyRound', color: 'text-blue-400' },
                { text: 'VPN: ¿cuándo la necesitas?', icon: 'Wifi', color: 'text-purple-400' },
                { text: 'Backup y regla 3-2-1', icon: 'HardDrive', color: 'text-emerald-400' },
                { text: 'GDPR: tus derechos', icon: 'Shield', color: 'text-cyan-400' },
                { text: 'Amenazas de fraude actuales', icon: 'AlertTriangle', color: 'text-amber-400' },
                { text: 'Nuevas amenazas y tendencias', icon: 'Eye', color: 'text-rose-400' }
            ]
        },
        knowledge_bank: {
            title: "Banco de conocimientos y Guías",
            subtitle: "Aprende cómo proteger tu privacidad digital con nuestras guías y artículos prácticos",
            read_more: "Leer más",
            read_time_suffix: "de lectura",
            guides: [
                {
                    title: "Lista de verificación de seguridad de 5 minutos",
                    description: "Acciones rápidas que puedes realizar hoy para mejorar significativamente tu seguridad digital.",
                    category: "Consejos rápidos"
                },
                {
                    title: "Dark Web: Cómo llegan tus datos allí",
                    description: "Comprende cómo se propagan los datos personales robados en la dark web y qué puedes hacer para protegerte.",
                    category: "Seguridad"
                },
                {
                    title: "Phishing: Cómo protegerse",
                    description: "Aprende a reconocer ataques de phishing, smishing y vishing antes de que te engañen con tu información.",
                    category: "Seguridad"
                }
            ]
        },
        cta_section: {
            title: "Deja de preocuparte por tus datos personales",
            subtitle: "Toma el control de tu privacidad digital hoy. Solo toma 2 minutos comenzar con Noctra.",
            button: "Comienza ahora"
        },
        footer_info: {
            description: "Noctra te ayuda a tomar el control de tu privacidad digital eliminando automáticamente tus datos personales de la web.",
            powered_by: "Impulsado por",
            org_nr: "Nº Reg."
        },
        faq: {
            categories: {
                all: "Todas las preguntas",
                getting_started: "Empezar",
                subscription: "Suscripción",
                privacy: "Privacidad",
                account: "Ajustes de la cuenta",
                notifications: "Notificaciones",
                security: "Seguridad",
                support: "Soporte"
            },
            items: [
                {
                    question: "¿Qué hace Noctra?",
                    answer: "Noctra te ayuda a eliminar tu información personal de los sitios de verificación de antecedentes como Ratsit, Hitta.se, MrKoll, Eniro y muchos más. Nosotros nos encargamos del proceso por ti y monitoreamos continuamente para que tu información no vuelva a aparecer."
                },
                {
                    question: "¿Cuánto tiempo pasa antes de que se elimine mi información?",
                    answer: "La mayoría de los sitios eliminan tu información en un plazo de 1 a 4 semanas. Algunos sitios pueden tardar más dependiendo de sus procesos internos. Puedes seguir el estado en tu panel de control."
                },
                {
                    question: "¿Qué sitios cubren?",
                    answer: "Cubrimos los principales sitios de verificación de antecedentes suecos: Ratsit, Hitta.se, MrKoll, Eniro, Merinfo, Birthday.se y muchos más. La lista se actualiza continuamente."
                },
                {
                    question: "¿Es legal eliminar la información de uno?",
                    answer: "¡Sí, por supuesto! De acuerdo con el GDPR, tienes el derecho de solicitar la eliminación de tus datos personales. Noctra te ayuda a ejercer este derecho."
                },
                {
                    question: "¿Cuánto cuesta Noctra?",
                    answer: "Ofrecemos diferentes paquetes desde 29 SEK/mes con facturación anual. Puedes ver todos nuestros precios en la página de inicio. También ofrecemos una búsqueda gratuita para que puedas ver dónde se encuentra tu información."
                },
                {
                    question: "¿Puedo cancelar mi suscripción?",
                    answer: "Sí, puedes cancelar tu suscripción en cualquier momento sin periodo de permanencia. Tu protección continúa hasta el final de tu periodo de facturación."
                },
                {
                    question: "¿Cómo sé que funciona?",
                    answer: "Recibes actualizaciones automáticas por correo electrónico y puedes seguir toda la actividad en tu panel de control en tiempo real. Mostramos exactamente con qué sitios nos hemos puesto en contacto y cuáles han confirmado la eliminación."
                },
                {
                    question: "¿Cómo manejan mi número de identidad personal?",
                    answer: "Procesamos tu número de identidad personal de forma segura y encriptada solo para poder identificarte en las bases de datos y solicitar la eliminación. Nunca lo compartimos con terceros no autorizados."
                },
                {
                    question: "¿Cómo cambio los detalles de mi cuenta?",
                    answer: "Puedes cambiar fácilmente los detalles de tu cuenta iniciando sesión en tu panel de control y yendo a Ajustes. Allí puedes actualizar el correo electrónico, la contraseña y otros ajustes del perfil."
                },
                {
                    question: "¿Qué métodos de pago aceptan?",
                    answer: "Aceptamos los principales métodos de pago: Visa, Mastercard, Klarna, PayPal, Apple Pay y Google Pay. Todos los pagos se procesan de forma segura a través de Stripe."
                },
                {
                    question: "¿Cómo me pongo en contacto con el soporte?",
                    answer: "Puedes ponerte en contacto con nuestro soporte por correo electrónico o a través de la función de chat en tu panel de control. Normalmente respondemos en un plazo de 24 horas en días laborables."
                },
                {
                    question: "¿Con qué frecuencia buscan mi información?",
                    answer: "Realizamos búsquedas continuas para asegurar que tu información no vuelva a aparecer. Los clientes Premium obtienen un monitoreo continuo con notificaciones directas."
                }
            ],
            guides_title: "No dudes en ver nuestras guías",
            guides_subtitle: "Obtén más información sobre cómo puedes proteger tu privacidad en línea.",
            guides: [
                {
                    title: "Guía de Registro",
                    description: "Guía sencilla para empezar con tu cuenta después de la compra."
                },
                {
                    title: "Guía de Uso",
                    description: "Todo lo que necesitas saber sobre cómo usar Noctra."
                },
                {
                    title: "Cómo funciona",
                    description: "Descubre cómo funciona nuestro servicio y qué sitios manejamos."
                },
                {
                    title: "Asociaciones",
                    description: "Ponte en contacto con nosotros para una asociación más segura y responsable."
                }
            ],
            hero: {
                title: "Preguntas Frecuentes",
                subtitle: "Aquí encontrarás respuestas a las preguntas más comunes sobre cómo funcionan nuestros servicios y qué puedes esperar de ellos. Si no encuentras la respuesta que buscas, ¡siempre puedes ponerte en contacto con nosotros!",
                filter_title: "¿Sobre qué quieres saber más?"
            },
            contact_cta: {
                title: "¿No encuentras la respuesta a tu pregunta?",
                subtitle: "Nuestro equipo de soporte está aquí para ayudarte. Contáctanos y responderemos tan pronto como podamos.",
                button: "Contáctanos",
                home_button: "Ir a la página de inicio"
            }
        }
    },
    auth: {
        login: {
                title: "Bienvenido de nuevo",
                subtitle: "Inicia sesión en tu cuenta",
                google: "Iniciar sesión con Google",
                apple: "Iniciar sesión con Apple",
                email_btn: "Iniciar sesión con Correo",
                or: "o",
                no_account: "¿No tienes una cuenta?",
                signup_link: "Empezar",
                email_label: "Correo electrónico",
                password_label: "Contraseña",
                forgot_password: "¿Olvidaste tu contraseña?",
                back: "Volver a opciones de inicio de sesión",
                submit: "Iniciar sesión",
                loading: "Iniciando sesión...",
                errors: {
                    generic: "Ocurrió un error",
                    no_email: "Ingresa tu correo primero",
                    check_email: "¡Revisa tu correo para el enlace de restablecimiento!"
                }
            },
            signup: {
                title: "Crear cuenta",
                subtitle: "Comienza y protege tu privacidad",
                google: "Continuar con Google",
                apple: "Continuar con Apple",
                email_btn: "Continuar con Correo",
                has_account: "¿Ya tienes una cuenta?",
                login_link: "Iniciar sesión",
                back: "Volver a opciones de registro",
                submit: "Crear cuenta",
                loading: "Creando cuenta...",
                success: "¡Revisa tu correo para confirmar tu cuenta!",
                errors: {
                    invalid_email: "Ingresa un correo electrónico válido",
                    password_length: "La contraseña debe tener al menos 6 caracteres.",
                    signups_disabled: "No es posible registrar nuevas cuentas en este momento.",
                    generic: "No se pudo crear la cuenta. Por favor, inténtalo de nuevo."
                }
            },
            footer: {
                agree: "Al continuar, aceptas nuestros",
                terms: "términos de servicio",
                and: "y que recibirás correos periódicos con actualizaciones y que has leído nuestra",
                privacy: "política de privacidad"
            },
            visual: {
                title: "Tu privacidad, tus términos",
                description: "Borramos tus rastros de la red para que puedas vivir sin que nadie no autorizado tenga acceso a tu información.",
                alt: "Aplicación Noctra en un smartphone"
            }
        },
        onboarding: {
            title: "¡Bienvenido a Noctra! 👋",
            subtitle: "Para protegerte y eliminar tus datos, necesitamos saber quién eres. Tus datos están encriptados y se usan solo para eliminación.",
            seo_title: "Comenzar - Noctra",
            seo_desc: "Crea tu cuenta y elige un plan para empezar a eliminar tus datos de internet.",
            steps: { verify: "Verificar", name: "Nombre", country: "País", address: "Dirección", plan: "Plan" },
            step1: {
                title_verify: "Verificar cuenta",
                title_signup: "Registrarse",
                subtitle_verify: "Confirma tu correo electrónico para continuar tu configuración.",
                subtitle_signup: "Introduce tu correo para crear tu cuenta de forma segura, sin contraseña.",
                email_label: "Correo electrónico",
                continue_btn: "Continuar",
                no_sell: "Nunca vendemos tus datos",
                verify_email_title: "Verificar correo",
                verify_email_subtitle1: "Hemos enviado un código de 6 dígitos a ",
                verify_email_link_subtitle1: "Hemos enviado un enlace de confirmación a ",
                verify_email_subtitle2: ". Ingresa el código a continuación.",
                verifying: "Verificando código...",
                send_new: "Enviar nuevo código",
                send_new_in: "Enviar nuevo código en",
                change_email: "¿Cambiar correo?",
                err_invalid_email: "Introduce un correo válido",
                err_no_signup: "El registro no está disponible ahora.",
                err_send: "No se pudo enviar el código. Inténtalo de nuevo.",
                err_invalid_code: "Código inválido o caducado. Inténtalo de nuevo.",
                check_inbox: "Haz clic en el enlace del correo para verificar tu cuenta.",
                waiting_confirm: "Esperando verificación..."

            },
            step2: {
                title: "Tu nombre",
                subtitle: "Ingresa tu nombre completo",
                err_full_name: "Por favor, ingresa tanto el nombre como los apellidos",
                err_save: "No se pudo guardar el nombre. Error: ",
                placeholder: "Nombre completo"
            },
            step3: {
                title: "¿En qué país vives?",
                subtitle: "Adaptamos nuestras búsquedas según tu región.",
                sweden: "Suecia",
                norway: "Noruega",
                denmark: "Dinamarca",
                finland: "Finlandia",
                err_save: "No se pudo guardar el país. Error: "
            },
            step4: {
                title: "¿Dónde vives?",
                subtitle: "Esta información se utiliza para escanear bases de datos y registros públicos en busca de tus datos.",
                street: "Dirección",
                zip: "Código Postal",
                city: "Ciudad",
                street_ph: "Ingresa la dirección",
                zip_ph: "Ingresa el código postal",
                city_ph: "Ingresa la ciudad",
                err_save: "No se pudo guardar la dirección. Error: "
            },
            step5: {
                title: "Elige tu plan",
                subtitle: "Siempre puedes actualizar o cambiar de plan más tarde",
                yearly: "Anual",
                save: "Ahorra 16%",
                monthly: "Mensual",
                no_binding: "Sin compromiso",
                err_payment: "Fallo al iniciar el pago. Intenta de nuevo.",
                onetime_title: "¿Solo necesitas arreglarlo una vez?",
                onetime_desc: "Eliminamos tus datos y enviamos un informe. Sin suscripción.",
                onetime_btn: "Limpieza única — 99 kr",
                guarantee: "Todos los planes incluyen 14 días de garantía. Cancela en cualquier momento.",
                free: {
                    period: "Siempre gratis",
                    description: "Empieza y explora tu visibilidad digital",
                    features: ["Panel de Noctra", "Ver tu nivel de privacidad", "Guías paso a paso", "Soporte por chat"],
                    cta: "Empezar gratis"
                },
                bas: {
                    period: "kr/mes",
                    description: "Protección continua — nosotros gestionamos la eliminación por ti",
                    features: ["Todo en Gratis", "Eliminación de más de 6 sitios", "Eliminación de enlaces y Google", "Alerta de dirección 24/7", "Gestión de casos con estado"],
                    cta: "Elegir Bas"
                },
                pro: {
                    period: "kr/mes",
                    description: "Máxima protección con Dark Web y escaneo de IA",
                    badge: "Más popular",
                    features: ["Todo en Bas", "Escaneo de Dark Web", "Visibilidad en IA (ChatGPT, Gemini etc.)", "Eliminación GDPR de servicios de IA", "Informe de seguridad semanal"],
                    cta: "Elegir Pro"
                }
            }
        },
        demos: {
            title: "Mira cómo Noctra funciona en la práctica",
            tabs: {
                monitoring: { title: "Monitoreo 24/7", desc: "Escanea la web en busca de amenazas" },
                removal: { title: "Borrar rastros", desc: "Te oculta de resultados de búsqueda" },
                alerts: { title: "Alarmas", desc: "Recibe avisos si encontramos algo" },
                google: { title: "Desindexación", desc: "Borrado de Google rápidamente" }
            },
            control: {
                protected: "Protegido",
                public: "Público",
                hidden: "Oculto al público",
                visible_hitta: "Visible en Hitta.se",
                visible_eniro: "Visible en Eniro",
                profile: "Tu Perfil",
                home_address: "Dirección",
                phone: "Número de Teléfono"
            },
            scan: {
                recognize: "El análisis reconoce:",
                ratsit: "Perfil de Ratsit",
                mrkoll: "Dirección en MrKoll",
                eniro: "Teléfono en Eniro",
                scanning: "Escaneando bases de datos...",
                identifying: "Identificando datos...",
                search_ratsit: "Buscando en Ratsit...",
                search_mrkoll: "Buscando en MrKoll...",
                search_eniro: "Buscando en Eniro...",
                search_hitta: "Buscando en Hitta.se...",
                found: "encontrados",
                protected: "protegidos"
            },
            google: {
                removed: "Eliminado de Google",
                reason: "Resultado desindexado por solicitud de privacidad",
                desc: "Información eliminada e inaccesible...",
                removed_result: "Resultado eliminado",
                your_profile: "Tu Perfil",
                all_removed: "¡Todos los resultados eliminados!",
                invisible: "Tu perfil ahora es invisible en los buscadores."
            },
            notification: {
                new_finding: "Nuevo HALLAZGO",
                finding_desc: "Descubrimos tus datos en",
                new_change: "Nuevo CAMBIO",
                change_desc: "Tu dirección ha sido cambiada fuera de nuestro sistema",
                deleted: "Borrado de",
                deleted_desc: "Tus datos han sido eliminados permanentemente de",
                done: "Listo",
                protection_active: "Protección activa",
                all_updated: "Todos los casos actualizados",
                activity: "Actividad",
                live: "En vivo",
                searching: "Buscando tus datos...",
                sources_found: "12 fuentes identificadas",
                sending_ratsit: "Enviando solicitud a Ratsit",
                removed_ratsit: "Eliminado de Ratsit",
                sending_hitta: "Enviando a Hitta.se",
                removed_hitta: "Eliminado de Hitta.se",
                clearing_google: "Borrando búsqueda en Google",
                removed_google_link: "Enlace de Google eliminado",
                done_status: "Listo",
                processing_status: "En proceso",
                now: "ahora",
                all_removed_notif: "✅ ¡Todos los datos eliminados! Ahora estás protegido."
            },
            removal: {
                age: "Edad: 42 años",
                salary_btn: "Ver salario de Lars anónimamente",
                ssn_label: "Número de identificación:",
                remove: "Eliminar",
                identifying: "Identificando",
                removed: "Eliminado"
            },
            mockups: {
                greeting: "Hola Lars 👋",
                privacy_level: "Nivel de privacidad",
                fully_protected: "Totalmente protegido",
                information_sites: "Sitios de información",
                removed: "Eliminado",
                cases_title: "Casos activos",
                just_now: "Justo ahora",
                in_queue: "En cola",
                google_link: "Enlace de Google",
                support: {
                    agent_greeting: "¡Hola! 👋 Soy Robin, tu asesor personal. ¿En qué puedo ayudarte?",
                    agent_role: "Robin de Noctra",
                    online: "En línea",
                    user_msg: "¿Debo hacer algo más después de que eliminen mis datos?",
                    agent_reply: "¡No, solo relájate! 😊 Nos encargamos del monitoreo y limpieza automáticamente. Recibirás una notificación si aparece algo nuevo."
                }
            },
            carousel: {
                title_1: "Encontramos tus datos",
                desc_1: "Escaneamos la red e identificamos dónde están públicos tus datos, incluso en sitios que no conocías.",
                title_2: "Los eliminamos",
                desc_2: "Enviamos solicitudes de eliminación automáticas a sitios como Hitta.se, MrKoll, Ratsit y muchas más bases de datos.",
                title_3: "Sigue el proceso en tiempo real",
                desc_3: "Recibe notificaciones en tu teléfono en cada paso, desde la identificación hasta la eliminación.",
                title_4: "Hazte invisible en las búsquedas",
                desc_4: "Nos aseguramos de que tus datos desaparezcan de Google y otros buscadores para que nadie pueda buscarte."
            }
        },
        address_monitoring: {
            premium_title: 'Alerta de Dirección — Premium',
            premium_desc: 'Como usuario premium, monitoreamos tu dirección las 24 horas del día, los 7 días de la semana y te alertamos de inmediato si alguien no autorizado intenta registrarse en tu dirección.',
            view_plans: 'Ver nuestros planes',
            activate_title: 'Activar Alerta de Dirección',
            activate_desc: 'Recibe una notificación instantánea si alguien intenta cambiar tu dirección registrada. Monitoreamos la Agencia Tributaria y SPAR 24/7.',
            feature_alert: 'Alerta Instantánea',
            feature_alert_desc: 'SMS y correo electrónico en cambios',
            feature_monitor: 'Monitoreo 24/7',
            feature_monitor_desc: 'Verificaciones de registro en tiempo real',
            feature_block: 'Servicio de Bloqueo',
            feature_block_desc: 'Ayuda para detener el secuestro',
            activate_btn: 'Activar Protección Ahora',
            activating: 'Activando...',
            loading: 'Cargando...',
            alert_header: '🚨 ¡INTRUSO DETECTADO!',
            alert_desc: 'Una persona desconocida se ha registrado en tu dirección. Revisa tu correo electrónico para más detalles.',
            status_title: 'Estado de Alerta de Dirección',
            status_active: 'Monitoreo activo',
            status_monitored: 'Tu dirección está siendo monitoreada en tiempo real',
            check_btn: 'Verificar Ahora',
            checking: 'Verificando...',
            address_label: 'Tu Dirección Registrada',
            monitored_since: 'Monitoreada desde',
            settings_title: 'Ajustes Avanzados',
            settings_desc: 'Configura la protección contra intrusos para apartamentos y familia',
            apt_label: 'Número de Apartamento (opcional)',
            apt_placeholder: 'ej. 1101',
            apt_desc: 'Si vives en un apartamento, ingresa tu número de apartamento para detectar registros no autorizados',
            whitelist_label: 'Residentes/Familia Aprobados (opcional)',
            whitelist_placeholder: 'ej. Maria Svensson, Erik Andersson',
            whitelist_desc: 'Ingresa nombres separados por comas. El sistema no alertará si estas personas viven en tu dirección.',
            save_btn: 'Guardar Ajustes',
            saving: 'Guardando...',
            toast_success: '¡Alerta de dirección activada!',
            toast_error: 'No se pudo activar el monitoreo.',
            toast_generic_error: 'Ocurrió un error.',
            toast_fill_address: 'Por favor, completa tu dirección en "Mis Datos" primero.',
            toast_check_failed: 'La verificación falló.',
            toast_check_error: 'No se pudo realizar la verificación.',
            toast_settings_saved: '¡Ajustes guardados!',
            toast_settings_error: 'No se pudieron guardar los ajustes.',
            protection_status_safe: 'Tu dirección está protegida',
            protection_status_alert: '¡ADVERTENCIA: Cambio detectado!',
            last_checked: 'Última verificación',
            active_badge: 'ACTIVO',
            alarm_badge: 'ALERTA',
            monitored_address_label: 'Dirección Monitoreada',
            report_agency: 'Informar a la Agencia Tributaria →'
        },
        ai_visibility: {
            title: 'Visibilidad en IA',
            subtitle: 'Verificamos manualmente si tus datos personales aparecen en las respuestas de los servicios de IA más populares.',
            requestScan: 'Solicitar escaneo',
            requesting: 'Solicitando...',
            alreadyRequested: 'Escaneo en curso',
            scanPending: 'Hemos recibido tu solicitud. Nuestro equipo está revisando manualmente cada servicio de IA; se te notificará cuando los resultados estén listos.',
            scanCompleted: 'Escaneo completado',
            servicesChecked: 'servicios verificados',
            exposures: 'exposiciones encontradas',
            removals: 'eliminaciones',
            noDataFound: 'No se encontraron datos',
            dataFound: 'Datos encontrados',
            remove: 'Eliminar',
            ignore: 'Ignorar',
            details: 'Detalles',
            requestedAt: 'Solicitado',
            completedAt: 'Completado',
            infoText: 'Noctra verifica manualmente tus exposiciones en ChatGPT, Google Gemini, Claude, Microsoft Copilot y Perplexity. Si encontramos tus datos personales, puedes optar por solicitar su eliminación; nosotros nos encargamos de todo el proceso de GDPR por ti.',
            noScanYet: 'Aún no has solicitado un escaneo de IA. Haz clic a continuación para que revisemos tus exposiciones.',
            removed: 'Eliminado',
            removalRequested: 'Solicitado',
            premiumTitle: 'Visibilidad en IA — Premium',
            premiumDesc: 'Como usuario premium, encontramos y eliminamos tus datos personales de ChatGPT, Gemini y otros grandes modelos de IA.',
            viewPlans: 'Ver planes',
            errorRequest: 'No se pudo enviar la solicitud. Inténtalo de nuevo.',
            refresh: 'Actualizar',
            scanning: 'Escaneando',
            found: 'Encontrado',
            not_found: 'No encontrado',
            in_progress: 'En curso',
            ignored: 'Ignorado'
        },
        dark_web: {
            title: 'Escaneo de la Dark Web',
            subtitle: 'Comprobamos si tus datos personales se han filtrado en brechas de datos conocidas.',
            scan: 'Iniciar escaneo',
            scanning: 'Escaneando...',
            rescan: 'Escanear de nuevo',
            lastScan: 'Último escaneo',
            breachesFound: 'brechas encontradas',
            noBreaches: 'No se encontraron brechas',
            exposedData: 'Datos expuestos',
            severity: 'Severidad',
            high: 'Alta',
            critical: 'Crítica',
            medium: 'Media',
            recommendation: 'Recomendación',
            changePassword: 'Cambia tu contraseña inmediatamente',
            monitorAccount: 'Monitorea esta cuenta',
            enable2fa: 'Activa la autenticación de dos factores',
            totalExposures: 'Exposiciones totales',
            passwordLeaks: 'Filtraciones de contraseñas',
            scannedEmail: 'Correo escaneado',
            source: 'Fuente',
            indicative: 'Indicativo (coincidencia no confirmada)',
            affectedAccounts: 'cuentas afectadas',
            history: 'Historial de escaneo',
            infoText: 'Los resultados se basan en datos de Have I Been Pwned (HIBP), la base de datos de brechas de datos más grande del mundo.',
            leaks: 'filtraciones',
            passwords: 'contraseñas',
            security_priority: 'La seguridad es nuestra prioridad',
            all_data_checked: 'Todos los datos se verifican contra fuentes auténticas de la dark web y brechas conocidas.',
            premiumTitle: 'Escaneo de la Dark Web — Premium',
            premiumDesc: 'Como usuario premium, monitoreamos tus datos las 24 horas del día y te alertamos de inmediato si encontramos tu información en nuevas filtraciones.',
            viewPlans: 'Ver nuestros planes',
            searchTitle: 'Busca tu correo electrónico',
            accounts: 'cuentas',
            scanFailed: 'El escaneo falló'
        },
        link_removal: {
            title: 'Solicitar eliminación de enlace',
            subtitle: 'Pega un enlace que quieras eliminar de la web o motores de búsqueda',
            url_label: 'URL a eliminar',
            url_placeholder: 'https://ejemplo.com/pagina-con-tus-datos',
            type_label: 'Tipo de eliminación',
            type_search: 'Motor de búsqueda',
            type_search_desc: 'Eliminar de Google, Bing etc.',
            type_website: 'Sitio web',
            type_website_desc: 'Eliminar de un sitio web específico',
            desc_label: 'Descripción (opcional)',
            desc_placeholder: 'Describe por qué quieres eliminar este enlace, p.ej. qué información se muestra...',
            submit: 'Enviar solicitud',
            submitting: 'Enviando...',
            success: '¡Tu solicitud ha sido enviada!',
            success_desc: 'Estamos procesando tu solicitud y te notificaremos cuando esté lista.',
            history_title: 'Tus solicitudes',
            history_empty: 'No hay solicitudes activas',
            history_empty_desc: 'Tus solicitudes de eliminación de enlaces aparecerán aquí.',
            status_submitted: 'Enviado',
            status_processing: 'Procesando',
            status_removed: 'Eliminado',
            status_action: 'Acción Requerida',
            invalid_url: 'Ingresa una URL válida (empieza con http:// o https://)',
            new_request: 'Nueva solicitud',
            processing_time: 'Procesamos tu solicitud en un plazo de 1 a 3 días hábiles',
            future_cases: 'Tus futuros casos aparecerán aquí.',
            premiumTitle: 'Función Premium',
            premiumDesc: 'Como usuario premium, puedes solicitar la eliminación automática de datos personales de Google y otros sitios web.',
            viewPlans: 'Ver nuestros planes'
        },
        my_details: {
            title: 'Información Personal',
            verified: '✓ Verificado',
            full_name: 'Nombre Completo',
            ssn: 'Número de Seguro Social',
            ssn_desc: 'No se puede cambiar manualmente.',
            ssn_title: 'Contacta con soporte para cambiar el SSN',
            email: 'Correo Electrónico',
            phone: 'Número de Teléfono',
            address: 'Dirección',
            zip_code: 'Código Postal',
            city: 'Ciudad',
            save: 'Guardar Cambios',
            saving: 'Guardando...',
            success: '¡Datos guardados!',
            error: 'No se pudo guardar: ',
        },
        settings: {
            title: 'Ajustes',
            subscription: 'Suscripción',
            next_billing: 'Próximo cobro',
            active: 'Activo',
            manage_billing: 'Gestionar pagos en Stripe',
            notifications: 'Notificaciones',
            email_notif: 'Correo sobre nuevos casos',
            email_notif_desc: 'Recibe un correo cuando encontremos nueva información sobre ti.',
            weekly_report: 'Informe semanal',
            weekly_report_desc: 'Resumen de tu estado de seguridad.',
            security: 'Seguridad y Cuenta',
            password: 'Contraseña',
            password_desc: 'Restablece tu contraseña por correo.',
            change_password: 'Cambiar contraseña',
            sending: 'Enviando...',
            delete_account: 'Eliminar cuenta',
            delete_confirm: '¿Estás seguro de que quieres eliminar tu cuenta? Esto no se puede deshacer.',
            delete_support: 'Contacta con support@noctra.se para cerrar tu cuenta.',
            portal_opening: 'Abriendo el portal del cliente de Stripe...',
            portal_error: 'No se pudo abrir el portal del cliente. Contacta con soporte.',
            password_error: 'No se pudo enviar el enlace de restablecimiento: ',
            password_sent: '¡Se ha enviado un enlace de restablecimiento a tu correo!',
            unexpected_error: 'Ocurrió un error inesperado.',
            cancels_on: 'Se cancela el',
            cancelling: 'Cancelando...',
            email_enabled: 'Notificaciones por correo activadas',
            email_disabled: 'Notificaciones por correo desactivadas',
            weekly_enabled: 'Informe semanal activado',
            weekly_disabled: 'Informe semanal desactivado',
        },
        plans_page: {
            title: 'Elige tu plan',
            subtitle: 'Actualiza para obtener protección total y monitoreo continuo.',
            premium_active_title: '¡Tienes un plan activo!',
            premium_active_desc: 'Gracias por usar nuestro servicio. Tus funciones están desbloqueadas y activas en tu cuenta. No necesitas elegir un nuevo plan.',
            premium_active_badge: 'ACTIVO',
            yearly: 'Anual',
            save: 'Ahorra 16%',
            monthly: 'Mensual',
            onetime_title: '¿Solo necesitas una limpieza única?',
            onetime_desc: 'Limpieza completa con un informe. Sin suscripción requerida.',
            onetime_btn: 'Limpieza única — 99 kr',
            most_popular: 'Más popular',
            month_suffix: '/mes',
            year_suffix: 'kr / año',
            current_plan: 'Tu plan actual',
            choose_plan: 'Elegir plan',
            payment_error: 'No se pudo iniciar el pago. Inténtalo de nuevo.',
            trust: {
                payment: 'Pago Seguro',
                id: 'Protección de ID',
                support: 'Soporte Premium',
                commitment: 'Sin compromiso'
            },
            bas: {
                users: "Protección continua — 1 persona",
                features: [
                    "1 Persona",
                    "Eliminación de más de 7 sitios",
                    "Desindexación de Google (5 enlaces)",
                    "Informe de eliminación con pruebas",
                    "Monitoreo continuo 24/7",
                    "Re-eliminación automática",
                    "Alerta de dirección",
                    "Panel Noctra"
                ]
            },
            pro: {
                users: "Protección máxima — 2 personas incl.",
                features: [
                    "2 Personas incluidas",
                    "Todo lo del plan Básico incluido",
                    "Monitoreo de la Dark Web",
                    "Visibilidad en IA (ChatGPT, Gemini, etc.)",
                    "Desindexación de Google (10 enlaces)",
                    "Añadir miembros de la familia (+29 kr/mes)",
                    "Soporte prioritario"
                ]
            }
        },
        support_page: {
            title: 'Ayuda y Soporte',
            subtitle: 'Estamos aquí para ayudarte con tu privacidad.',
            contact_us: 'Contáctanos',
            thanks: '¡Gracias por tu mensaje!',
            thanks_desc: 'Te responderemos por correo electrónico lo antes posible, normalmente en menos de 24 horas.',
            send_new: 'Enviar un nuevo mensaje',
            subject: 'Asunto',
            select_subject: 'Seleccionar asunto...',
            subject_case: 'Pregunta sobre el caso',
            subject_billing: 'Facturación y Pago',
            subject_tech: 'Problema técnico',
            subject_other: 'Otro',
            message: 'Mensaje',
            placeholder: 'Describe tu caso aquí...',
            send_btn: 'Enviar mensaje',
            sending: 'Enviando...',
            live_chat: 'Mensajería Directa',
            chat_desc: 'Escribe directamente a nuestro equipo. Normalmente respondemos en 1 hora.',
            online: 'Estamos en línea ahora',
            faq: 'Preguntas Frecuentes',
            see_all: 'Ver todas las preguntas',
            error_send: 'No se pudo enviar el mensaje. Inténtalo de nuevo.',
            error_unexpected: 'Ocurrió un error inesperado.',
            faq_q1: "¿Cuánto tiempo tarda una eliminación?",
            faq_a1: "La mayoría de las eliminaciones se realizan en 1-2 semanas. Algunos sitios como MrKoll pueden tardar hasta 30 días, ya que requieren procesamiento manual.",
            faq_q2: "¿Volverán mis datos?",
            faq_a2: "Monitoreamos los sitios continuamente. Si tus datos vuelven a aparecer, recibirás una alarma y comenzaremos una nueva eliminación automáticamente.",
            faq_q3: "¿Qué incluye mi suscripción?",
            faq_a3: "Obtienes eliminaciones ilimitadas de todas las bases de datos conectadas, monitoreo de identidad en tiempo real y soporte prioritario."
        },
        
        how_it_works: {
            hero: {
                title: 'Cómo funciona',
                subtitle: 'Protege tu privacidad online en cuatro sencillos pasos. Nosotros nos encargamos de todo.'
            },
            steps: {
                step1: {
                    title: 'Elige un plan',
                    description: 'Compara y elige el plan que mejor se adapte a ti en función de cuántas personas necesiten protección. Todos nuestros paquetes incluyen la eliminación ilimitada de enlaces y la eliminación de sitios de información.',
                    cta: 'Ver nuestros planes'
                },
                step2: {
                    title: 'Activa tu cuenta',
                    description: 'Después de elegir tu plan deseado y completar tu compra, recibirás un correo de activación.',
                    phone: {
                        title: 'Activa tu cuenta',
                        greeting: 'Hola Axel',
                        desc: 'Tu cuenta ha sido creada y ahora puedes iniciar sesión para activarla.'
                    }
                },
                step3: {
                    title: 'Eliminación',
                    description: 'En tu cuenta puedes eliminarte instantáneamente de varios sitios de información. Te eliminamos de MrKoll y retiramos tus enlaces de Google. Puedes seguir todo el proceso directamente en la aplicación.',
                    phone_status: 'Estado de eliminación',
                    phone_found: 'Encontrado',
                    phone_removed: 'Eliminado'
                },
                step4: {
                    title: 'Monitoreo',
                    description: 'Nuestro monitoreo hace un seguimiento si aparecen nuevos enlaces sobre ti. Recibirás una notificación en la aplicación y podrás elegir inmediatamente si deseas que eliminemos el enlace.',
                    phone_active: 'Monitoreo activo',
                    phone_last: 'Último: Justo ahora',
                    phone_protected: 'Protegido',
                    phone_scanning: 'Escaneando fuentes',
                    phone_scanning_status: 'Escaneando...',
                    phone_results: 'No se encontraron nuevas coincidencias'
                }
            },
            pricing: {
                title: 'Oculta tus datos y protégete ahora',
                subtitle: 'Elige el plan que mejor se adapte a ti',
                yearly: 'Plan anual',
                save: 'Ahorra hasta un 16%',
                monthly: 'Mensual',
                guarantee: 'Política de devolución de 14 días · Cancela en cualquier momento',
                swipe: '← Desliza para ver ambos planes →',
                onetime_title: '¿Solo necesitas una solución puntual?',
                onetime_desc: 'Eliminamos tus datos de todos los sitios y enviamos un informe con pruebas.',
                onetime_btn: 'Limpieza única — 99 kr',
                best_value: 'Mejor valor',
                mo: 'mes',
                yr: 'año',
                no_binding: 'Sin compromiso',
                you_save: 'Ahorras',
                only: 'Solo',
                per_person: 'kr/persona',
                get_protected: 'Protégete ahora',
                loading: 'Cargando...'
            },
            trust: {
                payment: 'Paga de forma segura con',
                guarantee: '14 días de derecho a devolución',
                cancel: 'Cancela en cualquier momento',
                no_fees: 'Sin tarifas ocultas'
            },
            newsletter: {
                badge: 'Incluido en Pro',
                title: 'Mantente un paso adelante – cada semana',
                desc: 'Como cliente Pro, recibirás un boletín de seguridad semanal exclusivo con guías detalladas, amenazas actuales y consejos prácticos para proteger tu identidad.',
                cta: 'Actualizar a Pro',
                topics: [
                    'GDPR – tus derechos',
                    'Amenazas de fraude actuales',
                    'Nuevas amenazas y tendencias',
                    'Informe de seguridad semanal'
                ]
            },
            footer: {
                rights: 'Todos los derechos reservados.'
            }
        },
        cases_page: {
            site: 'Base de datos / Sitio',
            status: 'Estado',
            updated: 'Última actualización',
            details: 'Detalles',
            no_cases: 'No hay casos aún',
            no_cases_desc: 'Tus casos aparecerán aquí tan pronto como comencemos a escanear.',
            id: 'ID del caso',
            created: 'Creado',
            type: 'Tipo',
            website: 'Sitio web',
            description: 'Descripción',
            status_removed: 'Eliminado',
            status_processing: 'Procesando',
            status_action: 'Acción requerida',
            status_submitted: 'Enviado',
            status_unknown: 'Estado desconocido',
            type_new: 'Nueva solicitud',
            type_processing: 'En proceso',
            type_completed: 'Finalizado',
            type_action: 'Acción requerida',
            type_other: 'Otro',
            id_label: 'ID'
    },
    poa: {
        nav_label: 'Poder Notarial',
        title: 'Poder Notarial',
        subtitle: 'Para poder actuar en tu nombre, necesitas firmar un poder notarial digital.',
        legal_body_1: 'Por la presente autorizo a Lumidiom AB (nº reg. 559438-1647) a representarme en todos los asuntos relacionados con la eliminación, restricción y gestión de mis datos personales.',
        legal_body_2: 'Este poder notarial abarca el contacto con motores de búsqueda (como Google, Bing) y proveedores de servicios de búsqueda (como MrKoll, Ratsit, Hitta.se, Eniro, Lexbase, Krimfup, etc.). El agente tiene derecho a solicitar la eliminación en mi nombre según el artículo 17 del RGPD y a presentar objeciones según el artículo 21 del RGPD.',
        verification_title: 'Verificación',
        verification_body: 'Este documento se firma digitalmente a través del Sistema de Verificación de Noctra. La marca de tiempo, la dirección IP y la verificación de identidad se registran automáticamente al firmar.',
        checkbox_label: 'He leído y acepto el poder notarial anterior y autorizo a Lumidiom AB a actuar en mi nombre.',
        sign_button: 'Firmar digitalmente',
        signing: 'Firmando...',
        signed_title: 'Poder Notarial Firmado',
        signed_desc: 'Tu poder notarial está activo. Ahora podemos actuar en tu nombre.',
        signed_at: 'Firmado',
        version_label: 'Versión',
        status_active: 'Activo',
        error: 'No se pudo firmar el poder notarial. Inténtalo de nuevo.',
        security_note: 'Tu firma se registra de forma segura con marca de tiempo y dirección IP.',
        banner_title: 'Firma tu Poder Notarial',
        banner_desc: 'Necesitamos tu Poder Notarial para empezar a eliminar tus datos de internet.',
        banner_cta: 'Firmar ahora'
    }
};
